export const messages = {
  en: {
    reserveDiningManage: {
      searchTitle: 'Search Conditions',
      listTitle: 'Reservation Dining',
      addCatalog: 'Add Catalog',
      addCatalogFirst: 'Please add catalog first',
      addFirst: 'Please add first',
      goodsIdPlaceholder: 'Please enter goods ID',
      goodsNamePlaceholder: 'Please enter goods name',
      statePlaceholder: 'Please select status',
      stateNotOnline: 'Not Online',
      stateOnline: 'Online',
      goodsCover: 'Goods Cover',
      goodsName: 'Name(ID)',
      params: 'Parameters',
      reserveWay: 'Reservation Way',
      day: 'Day',
      week: 'Week',
      reserveCount: 'Reservation Count',
      reserveQuantity: 'Reservation Quantity',
      price: 'Price',
      validDate: 'Valid Date',
      reserveStartTime: 'Reservation Start Time',
      sort: 'Sort',
      state: 'Status',
      reserveDining: 'Reservation Dining',
      diningStatistics: 'Dining Statistics',
      dining: 'Dining',
      fetchError: 'Failed to fetch data',
      page: {
        subtitle: 'Maintain dining catalogs, quotas, prices and shelf status',
        empty: 'No dining data',
        loadFailed: 'Failed to load dining list',
        noCatalog: 'No catalog yet'
      }
    },
    reserveDining: {
      reservePerson: 'Reservation Person',
      reservePersonPlaceholder: 'Required, please enter reservation person',
      reservePersonRequired: 'Reservation person is required',
      reservePersonMaxLength: 'Reservation person cannot exceed 64 characters',
      reserveTel: 'Reservation Tel',
      reserveTelPlaceholder: 'Required, please enter reservation tel',
      reserveTelRequired: 'Reservation tel is required',
      reserveTelMaxLength: 'Reservation tel cannot exceed 11 characters',
      payWay: 'Payment Way',
      payWayPlaceholder: 'Please select payment way',
      payWayRequired: 'Payment way is required',
      cash: 'Cash',
      wechat: 'WeChat',
      alipay: 'Alipay',
      reserveQuantity: 'Reservation Quantity',
      reserveQuantityPlaceholder: 'Please select reservation quantity',
      unit: 'unit',
      receivableAmount: 'Receivable Amount',
      receivableAmountPlaceholder: 'Required, please enter receivable amount',
      receivableAmountRequired: 'Receivable amount is required',
      receivedAmount: 'Received Amount',
      receivedAmountPlaceholder: 'Required, please enter received amount',
      receivedAmountRequired: 'Received amount is required',
      reserveDate: 'Reservation Date',
      reserveDatePlaceholder: 'Required, please select reservation date',
      reserveDateRequired: 'Reservation date is required',
      reserveTime: 'Reservation Time',
      reserveTimePlaceholder: 'Required, please select reservation time',
      hour: 'hour',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please enter remark',
      remarkRequired: 'Remark is required',
      confirmDelete: 'Confirm to delete reservation dining?'
    }
  },
  zh: {
    reserveDiningManage: {
      searchTitle: '查询条件',
      listTitle: '预约甄选',
      addCatalog: '添加目录',
      addCatalogFirst: '请先添加目录',
      addFirst: '请先添加',
      goodsIdPlaceholder: '请输入商品ID',
      goodsNamePlaceholder: '请输入商品名称',
      statePlaceholder: '请选择状态',
      stateNotOnline: '未上线',
      stateOnline: '上线',
      goodsCover: '商品封面',
      goodsName: '名称(编号)',
      params: '参数',
      reserveWay: '预约方式',
      day: '日',
      week: '周',
      reserveCount: '预约次数',
      reserveQuantity: '预约数量',
      price: '单价',
      validDate: '有效期',
      reserveStartTime: '开始预约时间',
      sort: '排序',
      state: '状态',
      reserveDining: '预约甄选',
      diningStatistics: '就餐统计',
      dining: '就餐',
      fetchError: '获取数据失败',
      page: {
        subtitle: '维护就餐目录、额度、价格与上下架状态',
        empty: '暂无预约就餐数据',
        loadFailed: '获取预约就餐列表失败',
        noCatalog: '暂无目录'
      }
    },
    reserveDining: {
      reservePerson: '预约人',
      reservePersonPlaceholder: '必填，请填写预约人',
      reservePersonRequired: '预约人不能为空',
      reservePersonMaxLength: '预约人不能超过64个字符',
      reserveTel: '预约电话',
      reserveTelPlaceholder: '必填，请填写预约电话',
      reserveTelRequired: '预约电话不能为空',
      reserveTelMaxLength: '预约电话不能超过11个字符',
      payWay: '支付方式',
      payWayPlaceholder: '请选择支付方式',
      payWayRequired: '支付方式不能为空',
      cash: '现金',
      wechat: '微信',
      alipay: '支付宝',
      reserveQuantity: '预约数量',
      reserveQuantityPlaceholder: '请选择预约数量',
      unit: '个',
      receivableAmount: '应收金额',
      receivableAmountPlaceholder: '必填，请填写应收金额',
      receivableAmountRequired: '应收金额不能为空',
      receivedAmount: '实收金额',
      receivedAmountPlaceholder: '必填，请填写实收金额',
      receivedAmountRequired: '实收金额不能为空',
      reserveDate: '预约日期',
      reserveDatePlaceholder: '必填，请选择预约日期',
      reserveDateRequired: '预约日期不能为空',
      reserveTime: '预约时间',
      reserveTimePlaceholder: '必填，请选择预约时间',
      hour: '时',
      remark: '备注',
      remarkPlaceholder: '必填，请填写备注',
      remarkRequired: '备注不能为空',
      confirmDelete: '确定删除预约甄选?'
    }
  }
}